export default "__VITE_ASSET__aC9GJouz__"